/* eslint-disable camelcase */
import type {
  PaymentDetailsConfig,
  PaymentDetailsConfigDTO,
  ZuoraCreditCardDetailsOptions,
  ZuoraCreditCardDetailsOptionsDTO,
} from './types';

export const mapConfigDTOtoModel = (dto: PaymentDetailsConfigDTO): PaymentDetailsConfig => ({
  paymentMethodType: dto.payment_method_type,
  provider: dto.provider,
  options: dto.options,
});

export const mapZuoraCreditCardDetailsDTOtoModel = (
  dto: ZuoraCreditCardDetailsOptionsDTO,
): ZuoraCreditCardDetailsOptions => ({
  submitEnabled: 'true',
  style: 'inline',
  locale: 'en',
  id: dto.page_id,
  signature: dto.signature,
  key: dto.key,
  tenantId: dto.tenant_id,
  token: dto.token,
  url: dto.payment_pages_url,
  paymentGateway: dto.payment_gateway,
  field_accountId: dto.external_customer_id,
});
